// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"articlePreviewContainer_previewContainer__u1A70"};